import React, { useRef } from 'react';
import { Loader2, Send, Mic } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import { PetProfile } from '../../types';

interface AIChatViewProps {
  profile: PetProfile | null;
  chatMessages: {role: 'user' | 'ai', text: string}[];
  aiLoading: boolean;
  aiInput: string;
  setAiInput: (value: string) => void;
  handleAskAI: (e: React.FormEvent) => void;
  handleChatVoiceInput: () => void;
}

export const AIChatView: React.FC<AIChatViewProps> = ({
  profile,
  chatMessages,
  aiLoading,
  aiInput,
  setAiInput,
  handleAskAI,
  handleChatVoiceInput
}) => {
  const chatEndRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto space-y-4 hide-scrollbar p-2">
        {chatMessages.map((msg, i) => (
          <div key={i} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
            <div className={`max-w-[85%] p-4 rounded-3xl text-sm ${
              msg.role === 'user' 
                ? (profile?.type==='chat'?'bg-orange-500':'bg-indigo-600') + ' text-white rounded-tr-none' 
                : 'bg-white border rounded-tl-none shadow-sm'
            }`}>
              <ReactMarkdown className="markdown-body">{msg.text}</ReactMarkdown>
            </div>
          </div>
        ))}
        {aiLoading && <Loader2 className={`mx-auto animate-spin ${profile?.type==='chat'?'text-orange-500':'text-indigo-600'}`} />}
        <div ref={chatEndRef}/>
      </div>
      <form onSubmit={handleAskAI} className="mt-4 flex gap-2 items-center">
        <div className="flex-1 relative">
          <input 
            value={aiInput} 
            onChange={e=>setAiInput(e.target.value)} 
            className="w-full p-4 pr-12 bg-white border rounded-2xl outline-none focus:ring-2 ring-indigo-100" 
            placeholder="Posez votre question..." 
          />
          <button type="button" onClick={handleChatVoiceInput} className="absolute right-2 top-3 text-gray-400">
            <Mic size={20}/>
          </button>
        </div>
        <button type="submit" className={`p-4 rounded-2xl text-white shadow-lg ${profile?.type==='chat'?'bg-orange-600':'bg-indigo-600'}`}>
          <Send size={20}/>
        </button>
      </form>
    </div>
  );
};
